/** @format */

/** Calendar scripts */

/**
 * Calendar scripts - responsible for setting up and handling calendar filters
 *
 * On a filter change, a request will be made to retrieve a filtered calendar. The filters are set up to have
 * an OR relationship, so when we one is in used the value of the other filter will be reset
 */

import validateDate from 'validate-date';

document.addEventListener('DOMContentLoaded', function () {
    const START_DATE_PICKER = document.querySelector("duet-date-picker.start")
    const END_DATE_PICKER = document.querySelector("duet-date-picker.end")
    const DATE_RANGE_PICKER_SUBMIT_BUTTON = document.querySelector("#date-range-submit")

    let startDate, endDate;


    /**
     * Checks if an object is empty
     * @param {Object} objectName - object to check
     * @returns {boolean} - if empty return true
     */
    const isObjectEmpty = (objectName) => {
        return (
            objectName &&
            Object.keys(objectName).length === 0 &&
            objectName.constructor === Object
        );
    };


// Setting up date picker and event listener
    if (START_DATE_PICKER && END_DATE_PICKER) {
        const DATE_FORMAT = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/
        const dateAdapter = {
            parse(value = "", createDate) {
                const matches = value.match(DATE_FORMAT)

                if (matches) {
                    return createDate(matches[3], matches[1], matches[2])
                }
            },
            format(date) {
                // MM/DD/YYYY
                return [('0' + date.getDate()).slice(-2), ('0' + (date.getMonth() + 1)).slice(-2), date.getFullYear()].join('/');
            }
        }
        START_DATE_PICKER.dateAdapter = dateAdapter
        END_DATE_PICKER.dateAdapter = dateAdapter

        const localization = {
            buttonLabel: "Filter by date",
            placeholder: "Filter by date",
            selectedDateMessage: "Selected date is",
            prevMonthLabel: "Previous month",
            nextMonthLabel: "Next month",
            monthSelectLabel: "Month",
            yearSelectLabel: "Year",
            closeLabel: "Close window",
            calendarHeading: "Choose a date",
            locale: "en-GB",
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        }

        START_DATE_PICKER.localization = {...localization};
        END_DATE_PICKER.localization = {...localization};
        START_DATE_PICKER.localization.placeholder = START_DATE_PICKER.attributes.placeholder.value
        END_DATE_PICKER.localization.placeholder = END_DATE_PICKER.attributes.placeholder.value

        
        // open panel if navigated from menu

        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('choose-dates')) {

            const filterToggle = document.querySelector('.c-whats-on-header__filters .c-whats-on-header__toggle')
            if (filterToggle) {
                filterToggle.click()
            }

        }

        // When the start date picker is changed
        START_DATE_PICKER.addEventListener("duetChange", function (e) {
            startDate = e.detail.valueAsDate
            END_DATE_PICKER.min = e.detail.value

            if (!endDate) {
                END_DATE_PICKER.show()
            }
            handleDateSelect()
        })

        // When the start date input value changes
        START_DATE_PICKER.addEventListener("input", function (e) {
            startDate = e.target.value;
            console.log(validateDate(startDate, "boolean", "dd/mm/yyyy"));

            if (validateDate(startDate, "boolean", "dd/mm/yyyy")) {
                START_DATE_PICKER.value = convertDateFormat(startDate);
                ;
                handleDateSelect();
            }
        })

        // When the end date picker is changed
        END_DATE_PICKER.addEventListener("duetChange", function (e) {
            endDate = e.detail.valueAsDate;
            START_DATE_PICKER.max = e.detail.value;
            handleDateSelect();
        })

        // When the start date input value changes
        END_DATE_PICKER.addEventListener("input", function (e) {
            endDate = e.target.value;
            console.log(validateDate(endDate, "boolean", "dd/mm/yyyy"));

            if (validateDate(endDate, "boolean", "dd/mm/yyyy")) {
                END_DATE_PICKER.value = convertDateFormat(endDate);
                handleDateSelect();
            }
        })

        // Handle date selection
        function handleDateSelect() {
            if (startDate && endDate) {
                DATE_RANGE_PICKER_SUBMIT_BUTTON.removeAttribute("disabled")
            } else {
                DATE_RANGE_PICKER_SUBMIT_BUTTON.setAttribute("disabled", true)
            }
        }

        function convertDateFormat(dateStr) {

            const [day, month, year] = dateStr.split('/');
            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate;
        }

        const form = document.getElementById('date-filters')

        form.addEventListener('submit', event => {
            event.preventDefault()


            const data = new FormData(event.target)
            let dataObject = Object.fromEntries(data.entries())

            console.log(dataObject)


            const action = new URL(event.target.action)

            // Filter out empty values
            dataObject = Object.fromEntries(Object.entries(dataObject).filter(([_, v]) => v.length > 0));
            for (const [key, value] of Object.entries(dataObject)) {
                action.searchParams.set(key, value)
            }
            action.searchParams.delete('when')

            // For season page need to add url param of view when a date filter is applied
            if (document.body.classList.contains('single-season') && !action.searchParams.has('view')) {
                action.searchParams.set('view', 'all-events')
            }

            window.location.href = action.href

        })
    }
})

